import { Container } from "./customPage";

export interface Prize {
    id?: string;
    campaignID?: string;
    redemptionWalletID: string;
    name: string;
    isWinningPrize: boolean;
    clickToPlay: boolean;
    gameMechanicType: string;
    redemptionType: RedemptionType; //scan, link-voucher, display-voucher, form
    voucherCode?: string;
    unAllocatedComponent?: Container;
    allocatedComponent?: Container;
    redeemedComponent?: Container;
    expiredComponent?: Container;
    gameplayFaceCard?: Container | null;
    losingGameplayFaceCard?: Container | null;
    outcomeFaceCard?: Container;
    redemptionFaceCard?: Container;
    expiryDate?: string;
}

export enum RedemptionType {
    SCAN = "scan-qr-code",
    TAP_REDEEM = "tap-to-redeem",
    VOUCHER = "voucher",
    LINK_VOUCHER = "url-voucher",
    YOYO_COUPON = "yoyo-coupon",
    MOMINT_NFT = "momint-nft",
}
